// Same fix as the wizard's FloatingField, generalized for the onboarding
// forms: a click in an input's top padding strip lands above the text line,
// so the browser drops the caret at the START of the value. Redirect those
// clicks to a caret-at-the-end focus. Attached once per form via event
// delegation (onMouseDown on the <form>), so every current and future input
// inherits it. Text-row clicks keep native caret placement.

import type React from 'react';

const SKIP_TYPES = new Set(['checkbox', 'radio', 'color', 'file', 'range', 'button', 'submit']);

export function redirectTopPaddingClickToCaretEnd(e: React.MouseEvent<HTMLElement>): void {
  const target = e.target as HTMLElement;
  const input = target.closest?.('input, textarea') as
    | HTMLInputElement
    | HTMLTextAreaElement
    | null;
  if (!input || input.disabled || input.readOnly) return;
  if (input instanceof HTMLInputElement && SKIP_TYPES.has(input.type)) return;

  const rect = input.getBoundingClientRect();
  const padTop = parseFloat(getComputedStyle(input).paddingTop) || 0;
  if (e.clientY < rect.top || e.clientY >= rect.top + padTop) return;

  e.preventDefault();
  input.focus();
  const end = input.value.length;
  try {
    input.setSelectionRange(end, end);
  } catch {
    // Some input types (email, number) reject setSelectionRange; the focus()
    // above is the best we can do for them.
  }
}
